import _ from 'lodash';

export class UserModel {

    hasSignedUp() {
        return _.isNumber(this.id) && this.id > 0;
    }
}

